/**
 * Extracts initials from a name string.
 * - Returns '?' for empty names
 * - Single word: returns first character
 * - Multiple words: returns first and last word initials
 */
export const getInitials = (name: string): string => {
  const partList = name.split(' ').filter(Boolean)
  if (partList.length === 0) return '?'
  if (partList.length === 1) return partList[0].charAt(0).toUpperCase()
  return (partList[0].charAt(0) + partList[partList.length - 1].charAt(0)).toUpperCase()
}
